<template>
  <CustomUpdateDialog
    :dialogTitle="`افزودن سوال به مسابقه ${matchTitle}`"
    dialogId="add-question-to-match-dialog"
    :isOkDisabled="isOkButtonDisabled"
    okTitle="افزودن"
    @ok="sendAddQuestionToMatchRequest"
  >
    <BCol cols="12">
      <QuestionPicker
        :inputLabel="computedQuestionPickerLabel"
        :selectable="isQuestionsSelectable"
        @getQuestions="setQuestions"
      ></QuestionPicker>
    </BCol>
  </CustomUpdateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedMatch: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      addQuestionsPayload: {
        matchId: null,
        questionIds: [],
      },
    };
  },
  methods: {
    async sendAddQuestionToMatchRequest() {
      try {
        this.isLoading = true;
        this.addQuestionsPayload.matchId = this.selectedMatch.id;
        let _this = this;
        let addQuestionsToMatch = new AddQuestionsToMatch(_this);
        addQuestionsToMatch.setRequestParamDataObj(_this.addQuestionsPayload);
        await addQuestionsToMatch.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "سوال با موفقیت به مسابقه افزوده شد.",
              },
            });
            _this.addQuestionsPayload = {
              matchId: null,
              questionIds: [],
            };
            this.$bvModal.hide("add-question-to-match-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setQuestions(questions) {
      this.addQuestionsPayload.questionIds = questions.map(
        (question) => question.questionId
      );
    },
    isQuestionsSelectable() {
      const maximumQuestionCount = this.selectedMatch.totalMatchQuestionsCount;
      const currentQuestionCount = this.selectedMatch.matchQuestionsCount;
      let addableQuestionsCount = 0;
      if (maximumQuestionCount > currentQuestionCount) {
        addableQuestionsCount = maximumQuestionCount - currentQuestionCount;
      }
      if (
        this.addQuestionsPayload.questionIds &&
        this.addQuestionsPayload.questionIds.length < addableQuestionsCount
      ) {
        return true;
      }
      return false;
    },
  },
  computed: {
    isOkButtonDisabled() {
      return false;
    },
    computedQuestionPickerLabel() {
      return `سوال های مورد نظر را انتخاب کنید ${
        this.tempSelectedMatchSetting &&
        this.tempSelectedMatchSetting.totalMatchQuestionsCount
          ? `(${this.tempSelectedMatchSetting.totalMatchQuestionsCount} سوال)`
          : ""
      }`;
    },
    matchTitle() {
      if (this.selectedMatch && this.selectedMatch.title) {
        return this.selectedMatch.title;
      }
      return "";
    },
  },
  components: {
    CustomUpdateDialog,
    QuestionPicker,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import QuestionPicker from "@/views/components/Questions/QuestionPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { AddQuestionsToMatch } from "@/libs/Api/Matches";
import { BCol } from "bootstrap-vue";
</script>
